import { useTranslation } from 'react-i18next'
import { useAuth } from '../hooks/useAuth'
import { cycleTheme } from './ThemeProvider'

export default function Topbar() {
  const { t, i18n } = useTranslation()
  const { user } = useAuth()

  const changeLanguage = (lng: string) => {
    i18n.changeLanguage(lng)
    localStorage.setItem('i18nextLng', lng)
  }

  return (
    <header className="a-topbar">
      <button className="a-mob-toggle" onClick={() => document.querySelector('.a-sidebar')?.classList.toggle('open')}>
        <i className="bi bi-list"></i>
      </button>

      <div className="a-topbar-brand">
        {user?.company_name || 'Adder Contracts'}
      </div>

      <div className="d-flex align-items-center gap-2">
        {/* Theme toggle */}
        <button className="a-theme-btn" onClick={() => cycleTheme()} title="Cambiar tema">
          <i className="bi bi-palette"></i>
        </button>

        {/* Language selector */}
        <div className="dropdown">
          <button className="a-theme-btn dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
            {i18n.language?.toUpperCase() || 'ES'}
          </button>
          <ul className="dropdown-menu dropdown-menu-end">
            <li><button className="dropdown-item" onClick={() => changeLanguage('es')}>ES - Español</button></li>
            <li><button className="dropdown-item" onClick={() => changeLanguage('en')}>EN - English</button></li>
          </ul>
        </div>
      </div>
    </header>
  )
}
